// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleDetail_ArticleRTE_container","rte":"ArticleDetail_ArticleRTE_rte"};